interface SettingsNudgeProps {
  /** Whether the current user is a company admin (only admins can reach the target settings screen). */
  isAdmin: boolean
  /** Navigate to the relevant admin settings screen. */
  onGo: () => void
  /** What's missing, e.g. "reply-to addresses" or "verified sending domains". */
  noun: string
  /** The admin call-to-action label, e.g. "Add reply-to addresses". */
  cta: string
}

/**
 * Amber empty-state hint for a missing sending prerequisite (a verified sending domain or a reply-to
 * address). Both live on admin-only settings screens, so an admin gets an actionable link there while a
 * non-admin is told to ask one — never a dead link to a screen they can't use.
 */
export function SettingsNudge({ isAdmin, onGo, noun, cta }: SettingsNudgeProps) {
  return (
    <p className="text-xs text-amber-600 dark:text-amber-400">
      No {noun} yet.{' '}
      {isAdmin ? (
        <button
          type="button"
          onClick={onGo}
          className="font-medium underline hover:text-amber-700 dark:hover:text-amber-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 rounded"
        >
          {cta}
        </button>
      ) : (
        <span>Ask a company admin to set them up.</span>
      )}
    </p>
  )
}
